module.exports = __webpack_public_path__ + "static/jago_logo-f2ccb718a8b051bd52b3d12bf2807db5.png";